import { ReactNode } from "react";
import { Modal } from "react-bootstrap";

interface IDialogBody {
    children: ReactNode
}

function DialogBody(props:IDialogBody) {
    return (
        <Modal.Body className="body" {...props}>
            {props.children}
        </Modal.Body>
    );
}

export default DialogBody;
